import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconNaturePeople = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconNaturePeople",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M180-520q-26 0-43-17t-17-43 17-43 43-17 43 17 17 43-17 43-43 17m60 360h320v-200h-70q-71 0-120-49t-50-121q0-53 29-94t73-62q11-65 61-109t117-45 118 45 60 109q45 20 74 62t28 94q0 71-49 121t-121 49h-70v200h160q17 0 29 12t11 28-11 29-29 11H160q-17 0-28-11t-12-29v-160q-11-11-25-17t-15-23v-120q0-17 12-28t28-12h120q17 0 29 12t11 28v120q0 16-14 23t-26 17z"
  })
}));
IconNaturePeople.displayName = 'IconNaturePeople';